<template>
  <v-dialog v-model="isShowList" persistent max-width="550px">
    <v-card>
      <v-card-title>
        <h3>{{ systemId }}'s {{ dscList.name }}</h3>
        <v-spacer></v-spacer>
        <v-btn icon x-small @click="closeListComp()">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-container>
        <div>
          <!-- eslint-disable-next-line prettier/prettier -->
          <v-data-table
            v-model="selected" :headers="headers" :items="metaList" item-key="dateTime" :loading="listLoading"
            dense fixed-header disable-pagination hide-default-footer height="350px"
            show-select class="metaListContent" @click:row="toggleSelect"
          >
            <template v-slot:top>
              <v-row>
                <v-col cols="12" class="text-right">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" x-small color="primary" right class="mr-2" @click.stop="delDialog = true" :disabled="disableDelete">
                        <v-icon small>mdi-trash-can-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('common.delete') }}</span>
                  </v-tooltip>
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn v-on="on" x-small right color="primary" @click="emitOpenForm" :disabled="disableCollect">
                        <v-icon small>mdi-plus-circle-outline</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t('meta.collection') }}</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </template>
            <template v-slot:item.dateTime="{ item }">{{ item.dateTime | reformatdate }}</template>
            <template v-slot:item.dataCount="{ item }"> {{ item.dataCount | comma }} </template>
          </v-data-table>
        </div>
      </v-container>
      <v-dialog v-model="delDialog" max-width="300px">
        <v-card>
          <v-card-title>{{ this.$t('meta.collect.delete') }}</v-card-title>
          <v-card-text class="meta-form-pd">{{ deleteMessage }}</v-card-text>
          <v-card-actions class="pa-4">
            <v-spacer></v-spacer>
            <v-btn small @click="resetSelected">{{ this.$t('common.cancel') }}</v-btn>
            <v-btn small @click="delDescription">{{ this.$t('common.confirm') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';
import { format } from 'date-fns';

export default {
  name: 'MetaDataList',
  props: {
    dscList: Object,
    systemId: String,
    open: Boolean,
  },
  data() {
    return {
      isShowList: false,
      listLoading: true,
      delDialog: false,
      metaList: [],
      selected: [],
      payload: {},
    };
  },
  filters: {
    reformatdate(value) {
      if (!value) return '';
      return format(new Date(value), 'yyyy.MM.dd');
    },
  },
  computed: {
    ...mapState('preference/meta', ['descriptions', 'delSuccess']),
    headers() {
      const headers = [
        { text: this.$t('meta.collectDate'), value: 'dateTime', width: '25%', sortable: false },
        { text: this.$t('meta.count'), value: 'dataCount', sortable: false, align: 'end' },
        { text: this.$t('meta.collectReason'), value: 'reason', sortable: false },
      ];

      return headers;
    },
    disableCollect() {
      // META_SAP_BATCH 내역은 추가 수집 기능이 없다.
      if (this.metaList.length > 0 && this.metaList[0].tableName == 'META_SAP_BATCH') return true;
      else return false;
    },
    disableDelete() {
      return this.selected.length ? false : true;
    },
    deleteMessage() {
      if (this.metaList.length > 0 && this.metaList[0].tableName == 'META_SAP_BATCH') return this.$t('meta.delete.batch.q');
      else return this.$t('common.delete.q');
    },
  },
  watch: {
    dscList(val) {
      if (val) {
        this.select();
      }
    },
    descriptions(value) {
      this.metaList = value;
    },
    metaList(value) {
      if (value) this.listLoading = false;
    },
    delSuccess(val) {
      if (val === 'success') {
        this.resetSelected();
      }
    },
  },
  methods: {
    toggleSelect(item, row) {
      row.isSelected ? row.select(false) : row.select(true);
    },
    resetSelected() {
      this.selected = [];
      this.delDialog = false;
    },
    select() {
      this.listLoading = true;
      this.payload = {
        systemId: this.systemId,
        tableName: this.dscList.metaSap.tableName,
      };
      this.$store.dispatch('preference/meta/getDescriptions', this.payload);
    },
    delDescription() {
      this.delDialog = false;
      this.payload.setectedDate = this.selected.map(chk => chk.dateTime).join(',');
      this.$store.dispatch('preference/meta/deleteDescriptions', { ...this.payload });
    },
    closeListComp() {
      this.resetSelected();
      this.isShowList = false;
    },
    emitOpenForm() {
      this.$emit('openform', { ...this.dscList });
    },
  },
};
</script>
